<template>
    <!-- 云对接项目 -->
    <el-row :gutter="15">
        <el-col :xs="24" :sm="8" v-for="(item,index) in itemData" :key="index">
            <div class="CloudDockingProject">
                <router-link :to="{ path:'DockingDetails',query: { id: item.id }} ">

                    <div class="top" :class="item.Prediction?'Prediction':''">
                        <img :src="item.coverurl" alt="">
                        <div class="topAfter">
                            {{item.start_time}}
                        </div>
                    </div>
                </router-link>
                <div class="bottom">
                    <router-link :to="{ path:'DockingDetails',query: { id: item.id }} ">
                        <p class="bottomTitle">
                            {{item.title}}
                        </p>
                        <span class="bottomSpan">
                            {{item.content}}
                        </span>
                    </router-link>
                    <div class="footerButton">
                        <div class="footerButtonLeft">
                            <img src="../../../../public/static/images/site1.png" alt="">
                            <span>
                                {{item.place}}
                            </span>
                        </div>
                        <div class="footerButtonRight">
                            <!-- 收藏 -->
                            <Collection :type="'event'" :id="item.id" :collect="item.collect" :state="false" />
                            <div class="footerButtonRight_R">
                                <img src="../../../../public/static/images/play2.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </el-col>
    </el-row>
</template>

<script>
    import Collection from "@/components/Collection/Collection.vue";//收藏
    export default {
        props: {
            itemData: Array,

        },
        components: { Collection },
        data() {
            return {
                list: [],//数据存放

            }
        },
        watch: {
            itemData: function (val) {
                console.log('val', val);
                let timestamp = Date.parse(new Date());//当前时间戳
                console.log('timestamp1', timestamp);

                for (let i in val) {
                    let start_time = Date.parse(val[i].start_time);//活动开始时间戳
                    if (timestamp < start_time) {
                        val[i].Prediction = true;//当前时间较早，需要预告
                    } else {
                        val[i].Prediction = false;//不需要预告
                    }
                }

            },
            deep: true,
            immediate: true,

        },
        created: function () {

        },
        methods: {},

    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .CloudDockingProject {
            margin-bottom: 20px !important;
        }
    }

    .CloudDockingProject {
        /* width: 369px; */
        margin-bottom: 43px;
        border-radius: 25px;
        overflow: hidden;
    }

    .topAfter {
        padding: 13px 24px;
        position: absolute;
        bottom: -18px;
        left: 0;
        background-color: #fec800;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333434;
    }

    .top {
        position: relative;
    }

    .Prediction::before {
        position: absolute;
        top: 10px;
        left: 10px;
        content: '预告';
        display: block;
        font-size: 16px;
        letter-spacing: 0px;
        color: #333434;
        background-color: #00ffff;
        border-radius: 15px;
        /* padding:10px 18px ; */
        width: 71px;
        height: 34px;
        text-align: center;
        line-height: 34px;
    }

    .top img {
        display: block;
        width: 100%;
        height: 208px;
    }

    .bottom {
        background-color: #fff;
        padding: 0 24px 0 33px;

    }

    .bottomTitle {
        padding-top: 38px;

        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
    }

    .bottomSpan {
        display: block;
        margin-top: 18px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #3e3e3e;
    }

    .footerButton {

        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333434;
        display: flex;
        justify-content: space-between;
        margin-top: 23px;
        padding-bottom: 21px;

    }

    .footerButtonLeft {
        margin: 9px 0 10px;
        position: relative;
    }

    .footerButtonLeft img {
        display: inline-block;
        position: relative;
        top: 3px;
    }

    .footerButtonLeft span {
        margin-left: 7px;
    }

    .footerButtonRight {

        display: flex;
        justify-content: space-between;
    }

    .footerButtonRight_L {
        margin: 9px 0 10px;
        margin-right: 24px;
    }

    .footerButtonRight_L span {
        margin-left: 5px;
    }

    .footerButtonRight_R {
        margin: 2px 0;
    }
</style>